import { AuditsSVG } from 'src/components/Icons/Basic'
import { ItemTitle } from 'src/components/PageLayout/ShowPage'
import {
  SecondaryButton,
  StandardButton,
} from 'src/components/Reusable/Buttons'
import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const AuditBotShowSectionSummary = styled.div`
  font-size: 20px;
  font-weight: 500;
`

export const AuditBotShowTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`
export const AuditBotShowButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`
export const AuditBotShowButtonContainer = styled.div`
  padding: 16px 0;
`
export const AuditBotShowSectionExplanation = styled.div`
  font-size: 14px;
  font-weight: 400;
`
export const AuditBotShowControlCountsContainer = styled.div`
  font-size: 1rem;
  font-weight: 400;
`
export const AuditBotShowControlCounts = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 14px;
`
export const AuditBotShowSectionContainer = styled.div`
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
`

export const AuditBotShowSectionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25em;
  margin-bottom: 1em;
`

export const AuditBotShowSectionSummaryContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 0.5rem;
`

export const AuditBotCancelButton = styled(StandardButton)`
  margin-bottom: 42px;
`
export const AuditBotStyledHeaderButton = styled(SecondaryButton)`
  margin-bottom: 8px;
  width: max-content;
`

export const CancelledScanHeaderTitle = styled(ItemTitle)`
  color: ${palette.magenta[400]};
`

export const CancelledControlChecksSummaryContainer = styled.div`
  display: flex;
  gap: 0.5em;
`

export const CancelledControlChecksSummaryText = styled.div`
  color: ${palette.magenta[400]};
`

export const AuditScanAuditIcon = styled(AuditsSVG)`
  path {
    fill: ${palette.neutral[600]};
  }
`
